module.exports = __webpack_public_path__ + "static/media/star_12.aa604afd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/star/star_12.jpg
// module id = 537
// module chunks = 0